// import { ClientInterface } from '@chegg/rio-sdk-web/dist/types/types'

export var CHEGG_PRODUCT = 'chegg_writing';
export var EASYBIB_PRODUCT = 'easybib_plus';
export var BIBME_PRODUCT = 'bibme_plus';
export var CITATION_MACHINE_PRODUCT = 'citation_machine_plus';
export var CHEGG_EXPERIENCE = 'cw';
export var BIBME_EXPERIENCE = 'bm';
export var CITATION_MACHINE_EXPERIENCE = 'cm';
export var EASYBIB_EXPERIENCE = 'eb';